<template>
    <div class="terms-sec tvod-optin">
        <h2 class="tit-h2 tvod-doc-title"><strong>LG Movies &amp; TV Targeted Advertising Opt-In Agreement</strong></h2>

        <p>This Targeted Advertising Agreement (&quot;Agreement&quot;) governs the use of your personal data for targeted advertising purposes in connection with the LG Movies &amp; TV App (&quot;App&quot; or &quot;Service&quot;). By clicking &quot;I Agree&quot; or otherwise indicating your consent, you agree to the terms set forth below. Please note that this Agreement is effective only if you have also consented to the Interest-Based &amp; Cross-Device Advertising Agreement at the device level on your LG Smart Media Product. If you have not consented to device-level interest based advertising, your data collected through this App will not be used for targeted advertising purposes.</p>

        <h3 class="tit-h3 tvod-sec-title"><strong>1. What Data We Collect and Use</strong></h3>
        <p>If you consent to this Agreement, we will collect and use the following data for targeted advertising purposes:</p>
        <ul class="terms-bullet">
            <li>Device Identifier (such as advertising ID/IFA, mac address)</li>
            <li>Usage Data: Information about your use of the Service, such as your viewing information, including your content viewing, purchase, or rental history (including the content you watch, the duration of content watched and preferences etc), how you browse our Service (including promotion banner clicks, page navigation, My Library and Wishlist activity), search queries, and other interactions with the App</li>
            <li>Transaction Data: Information about your purchase and rental activities within the App, such as the titles of content you have bought or rented and the transaction date. This data does not include personal financial information or identifiers, such as payment card details or unique transaction IDs.</li>
        </ul>

        <h3 class="tit-h3 tvod-sec-title"><strong>2. How We Use Your Data</strong></h3>
        <p>We use the data described above, combined with data collected at the device level, including Device Information and basic usage information (subject to your device level consent) to:</p>
        <ul class="terms-bullet">
            <li>Create audience segments based on data collected within the App combined with device-level data. Audience segment information is created based on your App Usage Data (including viewing information and other usage information), App transaction data combined with device-level data;</li>
            <li>Deliver personalized advertisements on the webOS Platform (e.g. webOS Home Screen) that may be more relevant to your interests;</li>
            <li>Measure and report on advertising effectiveness in aggregate, non identifiable, statistical form</li>
        </ul>

        <h3 class="tit-h3 tvod-sec-title"><strong>3. Sharing of Data with Advertising Partners</strong></h3>
        <p>To deliver targeted advertisements, we share your Advertising ID (AD ID) and audience segment information, which we create based on your Usage Data including viewing information in combination with device-level data (as described above in Section 2) with our third-party advertising technology partners including Alphonso. We do not share your raw viewing information or other Usage Data with these partners. Our third-party advertising partners use AD ID and audience segment information solely to deliver personalized advertisements on the webOS platform and to provide aggregate reporting on advertising performance.</p>

        <h3 class="tit-h3 tvod-sec-title"><strong>4. Your Right to Withdraw Consent</strong></h3>
        <p>You may withdraw your consent to targeted advertising at any time by going to Settings &gt; My Account &gt; User Agreements within the App and disabling the targeted advertising option. Upon withdrawal, we will cease using your data for targeted advertising purposes.</p>
        <p>If you have consented to the device level Interest based advertising agreement but not to this Agreement, you may still receive targeted advertisements on the webOS Platform based on device-level data; however, your data collected within the App will not be used for targeted advertising purposes.</p>

        <h3 class="tit-h3 tvod-sec-title"><strong>5. Other Opt-Out Mechanisms</strong></h3>
        <p>In addition to withdrawing consent through this Agreement, you may also limit targeted advertising through the following device settings:</p>
        <ul class="terms-bullet">
            <li><strong>Limit Ad Tracking (LMT):</strong> Enable this setting in your device's privacy settings to limit the use of your Advertising ID for targeted advertising across all apps</li>
            <li><strong>Do Not Sell My Personal Information (DNS):</strong> If available in your region, you may opt out of the sale or sharing of your personal information for advertising purposes</li>
            <li><strong>Parental Control Settings (PCS):</strong> if PCS are enabled at the device level or within the App, targeted advertising will be automatically restricted.</li>
        </ul>
        <p>If any of these device-level settings (i.e. LMT, DNS or PCS) or the App-level PCS are enabled to limit advertising, we will honor those preferences and restrict the use of your data for targeted advertising purposes, even if you have consented to this Agreement.</p>

        <h3 class="tit-h3 tvod-sec-title"><strong>6. Contact Us</strong></h3>
        <p>If you have any questions about this Agreement or how we use your data for targeted advertising, please contact us at: <a href="mailto:usprivacy@lge.com">usprivacy@lge.com</a> or <a href="mailto:tv.privacy@lge.com">tv.privacy@lge.com</a></p>

        <p><strong>Last updated: July 2026</strong></p>
    </div>
</template>

<script>
    export default {
        name: "TvodAdvertisingOptIn"
    }
</script>

<style scoped>
.tvod-doc-title {
    font-size: 2rem !important;
    line-height: 1.4 !important;
    margin: 0 0 1.6rem !important;
    font-family: 'NSB', 'LGB', sans-serif !important;
    font-weight: 600 !important;
    color: #333 !important;
}
.tvod-doc-title strong {
    font-family: 'NSB', 'LGB', sans-serif !important;
    font-weight: 600 !important;
}
.tvod-sec-title {
    font-size: 1.6rem !important;
    line-height: 1.4 !important;
    margin: 2.4rem 0 1.2rem !important;
    font-family: 'NSB', 'LGB', sans-serif !important;
    font-weight: 600 !important;
    color: #333 !important;
}
.tvod-sec-title strong {
    font-family: 'NSB', 'LGB', sans-serif !important;
    font-weight: 600 !important;
}
.tvod-optin strong {
    font-family: 'NSB', 'LGB', sans-serif !important;
    font-weight: 600 !important;
}
.terms-bullet {
    margin: 0 0 1.6rem 0 !important;
    padding: 0 0 0 2rem !important;
    list-style: disc !important;
}
.terms-bullet >>> li,
.terms-bullet li {
    display: list-item !important;
    list-style: disc !important;
    margin: 0 0 0.8rem !important;
    padding: 0 !important;
    line-height: 1.6;
}
.tvod-optin a {
    color: #0066cc;
    text-decoration: underline;
}
</style>
